import React from 'react';
import {
    Card, CardBody, Progress,  FormText, Button, Modal, ModalHeader, ModalBody, ModalFooter,
} from 'reactstrap';
import {appHelpers, store} from '../../_helpers';
 import NotificationSystem from 'react-notification-system';
 import {connect} from "react-redux";
import {alertActions, commonActions, modalActions} from "../../_actions";
import {alertConstants, appConstants} from "../../_constants";
import {apiActions} from "../../_actions/api.actions";
// import {apiService} from "../../_services";

//Page content util
import PageLoading from "../utils/page.loading";
import PageError from "../utils/page.error";
 // import SelectListComponent from "../utils/selectList";
import PageEmptyContent from "../utils/page.empty-content";
import IataValidationRecords from "./iata-validation-records";
//Icons
import AirportIcon from 'react-icons/lib/md/flight-land';
import InitiateIcon from 'react-icons/lib/md/library-add';
import IataFilterForm from "./filter-form";
import InitiateForm from "./initiate-form";
import {commonService} from "../../_services";
import moment from "moment/moment";
import {history} from '../../_helpers';


const ViewContent = ({children}) => (
    <div className="view-content view-components">
        {children}
    </div>
);

class IataViewContent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            airlines: [],
            users: [],
            validationRecords: [],
            Workflow: [],
            WorkflowActions: [],
            UserActionType: null,
            WorkflowFirstAction: null,
            FlightNumbers: [],
            airports: [],
            categories: [
                {
                    Id: 1,
                    Name : 'Domestic'
                },
                {
                    Id : 2,
                    Name: 'International'
                }
            ],
            modal: false,
            modalClass: '',
            //Validate form
            AirlineId: '',
            FlightNumber: '',
            StartFlightDate: new Date(),
            EndFlightDate: new Date(),
            DepartureAirportId: '',
            IsLocal: false,
            selectedCategory: 1,
            UserId: null,
            //Filter
            EndFilterFlightDate :  null,
            StartFilterFlightDate :  null,
            filterModes: [
                {
                    id: 1,
                    name: 'Airline'
                },
                {
                    id: 2,
                    name: 'Departure Airport'
                },
                {
                    id: 3,
                    name: 'Status'
                }
            ],
            currentFilterParameter: {},
            selectedFilterMode: '',
            filterOptions: [],
            filterValues: [],
            filterValueKey: '',
            filterLabelKey: '',
            IataValidationProcessName: appConstants.IATA_PROCESS_NAME,

            //page error
            contentError: false,  //Errors that affect content on the page
            errorMessage: false,
            componentError: false,  //Errors generated within the component
            componentErrorMessages: [],  //Errors generated within the component form
            error: false, //Error state mutable via Redux
            success: false, //Success message mutable via Redux

            //    Notification
            notification: {
                // title: 'Default Title',
                message: 'Default Message',
                level: 'success',
                position: 'tr',
                dismissible: true
            },

            // Pagination params
            pageSize: 10,
            currentPage: 1,
            totalRecordsCount: 0,
            IataValidationId: ''
        };

        this._notificationSystem = null;
        this._lastNotificationAdded = null;
    }

    componentDidMount() {
        this._notificationSystem = this.refs.notificationSystem;
        const reduxState = store.getState();
        let {airlinesCarriers, desAirports, users, authentication } = reduxState;
        if(airlinesCarriers){
            airlinesCarriers.Results.map(item => item.type = 1);
            this.setState({airlines: airlinesCarriers.Results})
        }else{
            this.fetchAirlines();
        }
        if(authentication){
            if(authentication.user !== undefined){
                this.setState({
                    UserId: authentication.user.userId
                });
                // this.getUserWorkflowAction(authentication.user.userId);
                this.setupComponents(authentication.user.userId)
            }
        }
        // Fetch  Airports
        if (desAirports) {
            this.setState({
                airports: desAirports.Results
            });
        } else {
            this.fetchAirports();
        }
        if(users){
            users.ResultList.map(item => item.Name = `${item.FirstName}  ${item.LastName}`);
            this.setState({users: users.ResultList })
        }else{
            this.fetchOrgUsers();
        }
        // this.getWorkflow();
        // this.fetchValidationRecords();

    }

    componentWillReceiveProps = function (nextProps) {
        const {alert} = nextProps;
        const {modal} = nextProps;

        if (alert) {
            if (alert.type === alertConstants.SUCCESS) {
                // this.setState({error: false, success: alert.message})
                this.setState({error: false, success: 'Operation successful'});
                this.resetForm();
            }
            else if (alert.type === alertConstants.CLEAR) {
                this.setState({success: false, error: false, errorMessage: false})

            } else {
                this.setState({success: false, error: alert.message})
            }
        }
        if (modal) {
            if (modal.type === appConstants.OPEN_MODAL) {
                this.setState({
                    modal: true,
                    modalClass: modal.modalClass
                });
            } else if (modal.type === appConstants.CLOSE_MODAL) {
                this.setState({
                    modal: false,
                    modalClass: modal.modalClass
                });
                this.resetForm();
            }
        }

    };

    handleChange = (event, attribute) => {
        let currState = this.state;
        currState[attribute] = event.target.value;
        let errorMessages = this.state.componentErrorMessages;
        errorMessages[attribute] = false;
        this.setState(currState);
        this.setState({componentErrorMessages: errorMessages});
    };

    handleSelectChange = (payload, attribute, stateAttribute) => {
        let currState = this.state;
        let errorMessages = this.state.componentErrorMessages;
        errorMessages[stateAttribute] = false;
        currState[stateAttribute] = (payload) ? payload[attribute] : ''; //Cater for setting up data and clearing data
        this.setState(currState);
    };
    handleFilterModeChange = (target) => {
        if(target){
            let currMode = target.id;
            this.setState({selectedFilterMode: currMode});
            switch (currMode){
                case 1:
                    return this.setState({ filterOptions: this.state.airlines, filterLabelKey: 'Id', filterValueKey: 'Name'});
                case 2:
                    return this.setState({ filterOptions: this.state.airports, filterLabelKey: 'Id', filterValueKey: 'Name'});
                case 3:
                    return this.setState({ filterOptions: this.state.WorkflowActions, filterLabelKey: 'Id', filterValueKey: 'Name'});
                default:
                    return this.setState({ filterOptions: this.state.airlines, filterLabelKey: 'Id', filterValueKey: 'Name'});
            }
        }else{
             this.setState({ filterOptions: [], selectedFilterMode: '' });

        }

    };
    handleSelectedFilterValuesChange = (target) => {
        let currFilterValues = this.state.filterValues;
        let newValue = target.filter(x => !currFilterValues.includes(x));
        let removedValue = currFilterValues.filter(x => !target.includes(x));
        if(removedValue.length === 0){
            let found = false;
            currFilterValues.forEach(function (item, key) {
                if(item.type === newValue[0].type){
                    currFilterValues[key] = newValue[0];
                    found = true;
                }
            });
            if(!found){
                currFilterValues = target;
            }
            this.setState({filterValues: currFilterValues});
        }else{
            this.setState({filterValues: target});
        }
    };

    validateInput = () => {
        let _errs_ = [];
        let formValid = true;
        if(this.state.AirlineId === ''){
            _errs_['AirlineId'] = 'Please select airline';
            formValid = false;
        }

        if(this.state.FlightNumber === ''){
            _errs_['FlightNumber'] = 'Please enter flight number';
            formValid = false;
        }

        if(this.state.DepartureAirportId === '') {
            _errs_['DepartureAirportId'] = 'Please select airport';
            formValid = false;
        }
        this.setState({componentErrorMessages: _errs_,  errorMessage: false});
        return formValid;
    };

    notify = (message, level) => {
        let notification = this.state.notification;
        notification['message'] = message;
        notification['level'] = level;
        notification.onRemove = this.onRemove;
        this._lastNotificationAdded = this._notificationSystem.addNotification(notification);
    };

    onRemove = (notification) => {
        if (this._lastNotificationAdded && notification.uid === this._lastNotificationAdded.uid) {
            this._lastNotificationAdded = null;
        }
    };

    resetForm() {
        this.setState({errorMessage: false, componentError: false, componentErrorMessages: [], selectedCategory: 1, AirlineId: '', FlightNumber: '', EndFlightDate:  new Date(), StartFlightDate: new Date(), DepartureAirportId: '' });
        this.resetError();
    }

    handleSubmit  = (event) => {
        event.preventDefault();
        this.setState({isRequesting: true});
        this.resetError();
        if(this.validateInput()){
            this.processSubmit();
        }
    };

    resetError() {
        this.props.dispatch(modalActions.clear());
        this.props.dispatch(alertActions.clear());
    }

    processSubmit = () => {
        let {airportId} = this.state;
        let payload = {
            Name: this.state.Name, Code: this.state.Code,
            CountryCode: this.state.CountryCode,
            IsLocal: this.state.IsLocal
        };
        if (airportId) {
            payload.Id = airportId;
        }
        const {dispatch} = this.props;
        dispatch(apiActions.startRequest());
        dispatch(commonActions.manageAirport(payload))
            .then(res => {
                if (res.status === appConstants.SUCCESS_RESPONSE) {
                    this.toggle(null, 'modalSlide');
                    let msg = (payload.Id) ? 'Airport edited successfully' : 'Airport created successfully';
                    this.notify(msg, appConstants.NOTIFY_SUCCESS);
                    this.fetchAirports();
                }
                else if (res.status === appConstants.ERROR_RESPONSE) {
                    dispatch(alertActions.error(res.response));
                    dispatch(apiActions.endRequest());
                }

            });
    };

    submitInitiateValidation = () => {
        const {dispatch} = this.props;
        const { selectedCategory, AirlineId, FlightNumber, StartFlightDate, DepartureAirportId, UserId } = this.state;
        if(this.validateInput()){
            dispatch(apiActions.startRequest());
            const payload = { UserId, AirlineId, FlightNumber, StartFlightDate : moment(StartFlightDate).format("YYYY-MM-DD") + "T00:00:00", EndFlightDate : moment(StartFlightDate).format('YYYY-MM-DD') + "T23:59:59", DepartureAirportId, IsLocal: (selectedCategory === 1) };
            commonService.postIATAValidation(payload)
                .then((res) => {
                    if (res.status === appConstants.SUCCESS_RESPONSE) {
                        dispatch(apiActions.endRequest());
                        this.notify('Record initiated successfully', appConstants.NOTIFY_SUCCESS);
                        history.push(`/iata-validation-page/${res.response.EntityId}`);
                        this.resetForm()
                    }
                    else if (res.status === appConstants.ERROR_RESPONSE) {
                        dispatch(apiActions.endRequest());
                        this.setState({errorMessage: res.response});
                    }
                });
        }


    };

    handleDateChange = (target) => {
        let componentErrorMessages = this.state.componentErrorMessages;
        componentErrorMessages['StartFlightDate'] = false;
        this.setState({StartFlightDate: target, componentErrorMessages: componentErrorMessages});
    };
    handleFilterDateChange = (FilterFlightDate, target) => {
        let curr_state = this.state;
        curr_state[target] = FilterFlightDate;
        this.setState(curr_state);
    };

    fetchOrgUsers = () => {
        this.setState({contentError: false});
        let { users } = store.getState();
        if(users){
            users.ResultList.map(item => item.Name = `${item.FirstName}  ${item.LastName}`);
            this.setState({users: users.ResultList })
        }else{
            const {dispatch} = this.props;
            const payload = { OrgId: appConstants.NCAA_ORG_ID  };
            // const payload = { };
            dispatch(commonActions.getUsersByOrganization(payload))
                .then(() => {
                    let { users } = this.props;
                    users.ResultList.map(item => item.Name = `${item.FirstName}  ${item.LastName}`);
                    this.setState({users: users.ResultList });
                }).catch(error => {
                let errorMessage = appHelpers.interpretErrorResponse(error);
                this.notify(errorMessage, appConstants.NOTIFY_ERROR);
                this.setState({contentError: errorMessage});
            });
        }
    };

    setupComponents = (userId) => {

        let { dispatch } = this.props;
        let { filterModes } = this.state;
        dispatch(apiActions.startFullPageRequest());
        // this.getUserWorkflowAction(authentication.user.userId)

        Promise.all([this.getWorkflow(), this.getUserWorkflowAction(userId)])
            .then(response => {
                let error_message = false;
                /*Process Workflow API */
            const workflowResponse = response[0];
            let WorkflowActions = workflowResponse.response.Results[0].WorkflowActions;
                WorkflowActions.map(item => item.type = 3); //add type for filter selection
                WorkflowActions.push({Id: new Date().getTime(), Name: 'Completed', isCompleted: true, type: 3}); //add status for the end of the process
            if (workflowResponse.status === appConstants.SUCCESS_RESPONSE) {
                if(workflowResponse.response.TotalCount > 0) {
                    this.setState({Workflow: workflowResponse.response.Results[0], WorkflowActions});
                    this.setWorkflowFirstAction(workflowResponse.response.Results[0].WorkflowActions);
                }else{
                    error_message =  'Workflow does not exist';
                }
            } else if (workflowResponse.status === appConstants.ERROR_RESPONSE) {
                error_message =  workflowResponse.response;
            }

            /*Process WorkflowAction API */
            const workflowActionResponse = response[1];
            if (workflowActionResponse.status === appConstants.SUCCESS_RESPONSE) {
                if(workflowActionResponse.response.TotalCount > 0) {

                    /*Process Validation API */
                    const UserActionType = workflowActionResponse.response.Results[0];

                    const WorkflowFirstAction = this.getWorkflowFirstAction(workflowResponse.response.Results[0].WorkflowActions);

                    this.handleFilterModeChange(filterModes[2]);
                    const defaultSelectedFilterValues = [{
                        ActionLevel: UserActionType.ActionLevel,
                        Id: UserActionType.WorkflowActionId,
                        Name: UserActionType.WorkflowActionName,
                        WorkflowId: UserActionType.Id,
                        WorkflowName: "",
                        type: 3
                    }];
                    this.handleSelectedFilterValuesChange(defaultSelectedFilterValues);

                    if(UserActionType.ActionLevel === WorkflowFirstAction.ActionLevel){
                        // Initiator logs in...
                        this.fetchValidationRecordsByUserId(UserActionType.UserId);
                    }else{
                        this.fetchValidationRecords( { WorkflowStatus: UserActionType.WorkflowActionName });
                    }
                    this.setState({ UserActionType: workflowActionResponse.response.Results[0]});
                }else{
                    error_message = 'You don\'t have privilege to continue';
                }
            } else if (workflowActionResponse.status === appConstants.ERROR_RESPONSE) {
                error_message =  workflowActionResponse.response;
            }
            this.setState({ contentError: error_message});

        }).catch(err => {
             this.setState({ contentError: 'Sorry, currently unable to display page'});
        });
    };

    fetchValidationRecords = (pageNumber, parameter) => {

        let { dispatch } = this.props;
        let { pageSize, UserActionType, WorkflowFirstAction } = this.state;

        parameter = (parameter) ? parameter : this.getFilterParameters();

        let fromIndex = 0;
        if(pageNumber === undefined){
            dispatch(apiActions.startFullPageRequest());
            //fromIndex = 0;
            pageNumber = 1;
        } else if(typeof pageNumber === "object"){
            // parameter = this.getFilterParameters();
            dispatch(apiActions.startRequest());
           // fromIndex = 0;
            pageNumber = 1;
        }else{
            fromIndex = pageSize * (pageNumber - 1);
            // parameter = this.getFilterParameters();
            dispatch(apiActions.startRequest());
        }
        let payload = {
            "From": fromIndex,
            "PageSize": pageSize,
            "Parameter": parameter
        };

        if((WorkflowFirstAction !== null && UserActionType !== null) && (UserActionType.ActionLevel === WorkflowFirstAction.ActionLevel)) {
            payload.Parameter.CreatedBy = UserActionType.UserId;
        }

        commonService.getIATAValidation(payload)
            .then((res) => {
                if (res.status === appConstants.SUCCESS_RESPONSE) {
                    const validationRecords = res.response.Results;
                    this.setState({originalRows: validationRecords, rows: [], validationRecords,  currentPage: pageNumber, totalRecordsCount : res.response.TotalCount});
                    dispatch(apiActions.endRequest());
                }
                else if (res.status === appConstants.ERROR_RESPONSE) {
                    this.notify('Currently unable to get records.', appConstants.NOTIFY_ERROR);
                    dispatch(apiActions.endRequest());
                }
            });
    };

    resetFilter = (e) => {
        e.preventDefault();
        let { dispatch } = this.props;
        let { pageSize } = this.state;
        let pageNumber = 1;
        dispatch(apiActions.startRequest());

        this.setState({filterOptions: [], filterValues : [], StartFilterFlightDate: null, EndFilterFlightDate: null, selectedFilterMode: ''})
        let payload = {
            "From": 0,
            "PageSize": pageSize,
            "Parameter":{
            }
        };
        commonService.getIATAValidation(payload)
            .then((res) => {
                if (res.status === appConstants.SUCCESS_RESPONSE) {
                    const validationRecords = res.response.Results;
                    this.setState({originalRows: validationRecords, rows: [], validationRecords,  currentPage: pageNumber, totalRecordsCount : res.response.TotalCount});
                    dispatch(apiActions.endRequest());
                }
                else if (res.status === appConstants.ERROR_RESPONSE) {
                    this.notify('Currently unable to get records.', appConstants.NOTIFY_ERROR);
                    dispatch(apiActions.endRequest());
                }
            });
    };

    getFilterParameters = () => {
        let { StartFilterFlightDate, EndFilterFlightDate, filterValues } = this.state;
        let ValidationStatus = null;
        let WorkflowStatus = null; let DepartureAirportId = null; let AirlineId = null;

        filterValues.map((item) => {
            if(item.type === 1){
                AirlineId = item.Id
            }
            else if(item.type === 3){
                if(item.isCompleted){
                    ValidationStatus = 1;
                }else{
                    WorkflowStatus = item.Name
                }
            }else if (item.type === undefined){
                DepartureAirportId = item.Id
            }
            return item;
        });
       let  parameter = { AirlineId, WorkflowStatus, DepartureAirportId};
        if(StartFilterFlightDate && EndFilterFlightDate){
            parameter.StartFlightDate = moment(StartFilterFlightDate).format("YYYY-MM-DD")  + "T00:00:00";
            parameter.EndFlightDate = moment(EndFilterFlightDate).format("YYYY-MM-DD")  + "T23:59:59";
        }
        if(ValidationStatus){
            parameter.ValidationStatus = ValidationStatus;
        }

        return parameter;
    }

    fetchValidationRecordsByUserId = (CreatedBy) => {
        let { dispatch } = this.props;
        let { pageSize } = this.state;
        dispatch(apiActions.startFullPageRequest());

        let parameters = this.getFilterParameters();
        let payload = {
            "From": 0,
            "PageSize": pageSize,
            "Parameter":{
                    CreatedBy, ...parameters
            }
        };
        commonService.getIATAValidation(payload)
            .then((res) => {
                if (res.status === appConstants.SUCCESS_RESPONSE) {
                    const validationRecords = res.response.Results;
                    this.setState({originalRows: validationRecords, rows: [], validationRecords,  currentPage: 1, totalRecordsCount : res.response.TotalCount});
                    dispatch(apiActions.endRequest());
                }
                else if (res.status === appConstants.ERROR_RESPONSE) {
                    this.notify('Currently unable to get records.', appConstants.NOTIFY_ERROR);
                    dispatch(apiActions.endRequest());
                }
            });
    };

    fetchAirlines = () => {
        this.setState({contentError: false});
        const {dispatch} = this.props;

        dispatch(commonActions.getAirlinesCarriers())
            .then(() => {
                let {airlinesCarriers} = this.props;
                let airlines = airlinesCarriers.Results;
                    airlines.map(item => item.type = 1);
                this.setState({airlines});
            }).catch(error => {
            let errorMessage = appHelpers.interpretErrorResponse(error);
            this.notify(errorMessage, appConstants.NOTIFY_ERROR);
            this.setState({contentError: errorMessage});
        });
    };

    fetchAirports = () => {
         this.setState({contentError: false});
        const {dispatch} = this.props;

        dispatch(commonActions.getDesAirports())
            .then(() => {
                let {desAirports} = this.props;
                this.setState({airports: desAirports.Results});
            }).catch(error => {
            let errorMessage = appHelpers.interpretErrorResponse(error);
            this.notify(errorMessage, appConstants.NOTIFY_ERROR);
            this.setState({contentError: errorMessage});
        });
    };

    handleAirlineChange = (target) => {
        if((target !== null)){
            //Get All flights for airline
            let AirlineId = (target) ? target.Id : '';
            this.setState({ AirlineId});
            const {dispatch} = this.props;
            dispatch(apiActions.startRequest());
            commonService.getAirlinesFlightNumbers(AirlineId)
                .then((res) => {
                    let response = res.response;
                    if(res.status === appConstants.SUCCESS_RESPONSE) {
                        this.setState({FlightNumbers: response.Results });
                    }
                    else if(res.status === appConstants.ERROR_RESPONSE){
                        this.notify(response, appConstants.NOTIFY_ERROR);
                    }
                    dispatch(apiActions.endRequest());
                });
        }else{
            this.setState({FlightNumbers: [], AirlineId: ''});
        }
    };

    handleFlightChange = (target) => {
        if((target !== null)){
            const { DepartureAirportId, FlightNumber } = target;
            this.setState({ DepartureAirportId, FlightNumber });
        }else{
            this.setState({DepartureAirportId: '', FlightNumber: ''});
        }
    };

    interpretUserId = (userId) => {
        const  { users } = this.state;
        let check = users.find(item => item.Id === userId);
        if(check){
            return check.Email;
        }else{
            return `Unknown User`;
        }
    };

    interpretAirline = (airlineId) => {
        const  { airlines } = this.state;
        let check = airlines.find(item => item.Id === airlineId);
        if(check){
            return check.Name;
        }else{
            return `Unknown Airline #${airlineId}`;
        }
    };
    interpretAirport = (airportId) => {
        const  { airports } = this.state;
        let check = airports.find(item => item.Id === airportId);
        if(check){
            return check.Name;
        }else{
            return `Unknown Airport #${airportId}`;
        }
    };
    toggle = (e, modalClass) => {
        if(this.state.modal){
            this.resetForm();
            this.props.dispatch(modalActions.close({'modalClass': modalClass}));
        }else{
            this.props.dispatch(modalActions.open({'modalClass': modalClass}));
        }
    };
    getUserWorkflowAction = (UserId) => {
        let  { IataValidationProcessName} = this.state;

        let payload = {
            "From": 0,
            "PageSize": 1,
        };
        let params = {
            WorkflowProcessName: IataValidationProcessName,
            UserId,
        };
        payload.Parameter = params;

        return commonService.getWorkFlowUsers(payload);
    };

    getWorkflow = () => {
        let  { IataValidationProcessName} = this.state;
        let payload = {
            "From": 0,
            "PageSize": 1,
        };
        let params = {
            WorkflowProcessName: IataValidationProcessName,
            IncludeWorkflowActions: true
        };
        payload.Parameter = params;
        return commonService.getWorkFlows(payload);
    };
    setWorkflowFirstAction = (workflowActions) => {
        let WorkflowFirstAction = workflowActions[0];
        for(let item of workflowActions){
            if(item.ActionLevel < WorkflowFirstAction.ActionLevel){
                WorkflowFirstAction = item
            }
        }
        this.setState({WorkflowFirstAction});
    };
    getWorkflowFirstAction = (workflowActions) => {
        let WorkflowFirstAction = workflowActions[0];
        for(let item of workflowActions){
            if(item.ActionLevel < WorkflowFirstAction.ActionLevel){
                WorkflowFirstAction = item
            }
        }
         return WorkflowFirstAction;
    };
    renderPageResponse() {
        if(this.state.error){
            return (<div className="alert alert-danger">{this.state.error}</div>);
        }
        else if(this.state.componentError){
            return (<div className="alert alert-danger">{this.state.componentError}</div>);
        }
        else if(this.state.success){
            return (<div className="alert alert-success">{this.state.success}</div>);
        }
    }

    render() {
        const { requesting } = this.props;
        const { pageRequesting } = this.props;
        const { WorkflowFirstAction, UserActionType, contentError, currentPage, pageSize, totalRecordsCount, validationRecords, airports, errorMessage, componentErrorMessages, categories, airlines, selectedCategory, AirlineId, FlightNumber, StartFlightDate, EndFlightDate, DepartureAirportId, FlightNumbers,
            filterModes, selectedFilterMode, filterOptions, filterValueKey, filterLabelKey, filterValues, StartFilterFlightDate, EndFilterFlightDate } = this.state;
        let validationRecordsLength = validationRecords.length;
        return (
            <div className="view">
                <ViewContent>
                    <Card className="mb-4">
                        {/*Progress bar for Pending API Request*/}
                        { ((pageRequesting || requesting) && !pageRequesting ) && <Progress animated striped color="success" value={100} className="mb-2"/> }

                        {/*Display loader when component content is dependent on Data from API*/}
                        { (!contentError && pageRequesting) &&
                        <PageLoading/>
                        }

                        {/*Display error when component fail to get Data from API*/}
                        { contentError &&
                             <PageError error={this.state.contentError }/>
                        }

                        {/*Display component content when Data is gotten from API*/}
                        { (!contentError && !pageRequesting) &&
                             <CardBody className="table-responsive">
                            <div className="row">
                                <h6 className="mb-4 col-md-4 text-uppercase pull-left">IATA Records
                                    <FormText color="muted">
                                        {
                                            (totalRecordsCount > 0) &&
                                            <div>
                                                <AirportIcon size="18" color="#43a8df"/>&nbsp;
                                                <span>{ totalRecordsCount }&nbsp;
                                                    { (totalRecordsCount === 1) ? 'record matched' : 'records matched' }
                                                 </span>
                                            </div>
                                        }
                                    </FormText>
                                </h6>
                                <div className="mb-4 col-md-8 text-right">
                                    {
                                        ((WorkflowFirstAction !== null && UserActionType !== null) && (UserActionType.ActionLevel === WorkflowFirstAction.ActionLevel)) &&
                                        <Button className="btn-avi-secondary"  onClick={this.toggle}>
                                            <InitiateIcon color="#ffffff" size="18"/>&nbsp; Initiate Process
                                        </Button>
                                        // <InitiateForm errorMessage={errorMessage} componentErrorMessages={componentErrorMessages} FlightNumbers={FlightNumbers} airports={airports} airlines={airlines} categories={categories} selectedCategory={selectedCategory} AirlineId={AirlineId} FlightNumber={FlightNumber} StartFlightDate={StartFlightDate} EndFlightDate={EndFlightDate} DepartureAirportId={DepartureAirportId} onSubmit={this.submitInitiateValidation} handleSelectChange={this.handleSelectChange} handleChange={this.handleChange} handleAirlineChange={this.handleAirlineChange} handleDateChange={this.handleDateChange} />

                                    }
                                </div>
                            </div>


                             {/* Filter records */}
                             <IataFilterForm
                                 filters={filterModes}
                                 selectedFilterMode={selectedFilterMode}
                                 filterOptions={filterOptions}
                                 filterValues={filterValues}
                                 filterLabelKey={filterLabelKey}
                                 filterValueKey={filterValueKey}
                                 errorMessage={errorMessage}
                                 airports={airports}
                                 airlines={airlines}
                                 EndFilterFlightDate={EndFilterFlightDate}
                                 StartFilterFlightDate={StartFilterFlightDate}
                                 onFilterModeValueChange={this.handleFilterModeChange}
                                 onSelectedFilterValuesChange={this.handleSelectedFilterValuesChange}
                                 onSearch={this.fetchValidationRecords}
                                 onReset={this.resetFilter}
                                 handleDateChange={this.handleFilterDateChange} />

                            {(!pageRequesting &&  validationRecordsLength > 0) &&
                              <IataValidationRecords data={ validationRecords }  pageDataCallback={this.fetchValidationRecords} interpretUserId={this.interpretUserId} interpretAirline={this.interpretAirline} interpretAirport={this.interpretAirport} currentPage={currentPage} pageSize={pageSize} totalRecordsCount={totalRecordsCount} />
                            }

                            {(!pageRequesting && validationRecordsLength === 0) &&
                                <PageEmptyContent message='No records yet!'/>
                            }
                                 <Modal size={'lg'} isOpen={this.state.modal} toggle={this.toggle} className={this.state.modalClass}>
                                     <ModalHeader toggle={this.toggle}>Initiate Process</ModalHeader>
                                          <ModalBody>
                                              {
                                                  errorMessage &&
                                                  <div className="alert alert-danger text-center">{errorMessage}</div>
                                              }
                                             <InitiateForm
                                                 errorMessage={errorMessage} componentErrorMessages={componentErrorMessages}
                                                 FlightNumbers={FlightNumbers} airports={airports} airlines={airlines}
                                                 categories={categories} selectedCategory={selectedCategory} AirlineId={AirlineId}
                                                 FlightNumber={FlightNumber} StartFlightDate={StartFlightDate} EndFlightDate={EndFlightDate}
                                                 DepartureAirportId={DepartureAirportId} onSubmit={this.submitInitiateValidation}
                                                 handleSelectChange={this.handleSelectChange} handleChange={this.handleChange}
                                                 handleFlightChange={this.handleFlightChange} handleAirlineChange={this.handleAirlineChange} handleDateChange={this.handleDateChange}
                                             />
                                         </ModalBody>
                                         <ModalFooter>
                                             <Button className="btn-avi-primary" disabled={ requesting } onClick={this.submitInitiateValidation} > Proceed </Button>{' '}
                                             <Button color="secondary" onClick={this.toggle}>Cancel</Button>
                                         </ModalFooter>
                                     { requesting &&  <div className={'loading-dot active'}></div>}
                                 </Modal>
                        </CardBody>
                        }
                        <NotificationSystem ref="notificationSystem"/>
                    </Card>
                </ViewContent>
            </div>
        );
    }
}
function mapStateToProps(state, ownProps) {
    const { loggingIn } = state.authentication;
    const { requesting, pageRequesting } = state.api;
    const { modal, alert, users, airlinesCarriers, desAirports} = state;
    return {
        loggingIn,
        requesting,
        pageRequesting,
        modal,
        alert,
        desAirports,
        airlinesCarriers,
        users
    };
}
export default connect(mapStateToProps)(IataViewContent);



// WEBPACK FOOTER //
// ./src/views/iataValidation/view-content.js